<template>
  <div class="sidebar-header">
    <div v-if="isLoading" class="sidebar-header__nav">
      <b-skeleton width="48px" height="24px"></b-skeleton>
    </div>
    <div v-else class="sidebar-header__nav">
      <button
        type="button"
        class="sidebar-header__nav-btn"
        title="Vorheriger Eintrag"
        @click="$emit('go-up')"
      >
        <ChevronLeft :size="20" />
      </button>
      <button
        type="button"
        class="sidebar-header__nav-btn"
        title="Nächster Eintrag"
        @click="$emit('go-down')"
      >
        <ChevronRight :size="20" />
      </button>
    </div>

    <div v-if="isLoading || !kuerzel" class="sidebar-header__titel">
      <b-skeleton width="164px" height="24px"></b-skeleton>
    </div>
    <div v-else class="sidebar-header__titel">
      <div class="sidebar-header__zeile">
        <a class="sidebar-header__link" :href="titleHref" target="_blank">
          <span class="sidebar-header__kuerzel">{{ kuerzel }}</span>
          <span v-if="datum" class="sidebar-header__datum">{{ datum }}</span>
        </a>
        <slot name="badge"></slot>
      </div>
      <span v-if="ursprung" class="sidebar-header__zusatz">
        Ehemals:
        <a target="blank" :href="'/#/reisetermine/' + ursprung.id">{{ ursprung.kuerzel }}</a>
      </span>
      <span v-if="ersatz" class="sidebar-header__zusatz">
        Ersatztermin:
        <a target="blank" :href="'/#/reisetermine/' + ersatz.id">{{ ersatz.kuerzel }}</a>
      </span>
    </div>

    <div v-if="isLoading" class="sidebar-header__aktionen">
      <b-skeleton width="120px" height="32px"></b-skeleton>
    </div>
    <div v-else class="sidebar-header__aktionen">
      <slot name="actions"></slot>
      <button type="button" class="sidebar-header__close" title="Schließen" @click="$emit('close')">
        <X :size="20" />
      </button>
    </div>
  </div>
</template>

<script>
import { ChevronLeft, ChevronRight, X } from 'lucide-vue';

export default {
  name: 'SidebarHeader',
  components: { ChevronLeft, ChevronRight, X },
  props: {
    isLoading: { type: Boolean, default: false },
    titleHref: { type: String, default: null },
    kuerzel: { type: String, default: '' },
    datum: { type: String, default: '' },
    // Verweise auf Ursprungs- und Ersatztermin als { id, kuerzel }
    ursprung: { type: Object, default: null },
    ersatz: { type: Object, default: null },
  },
};
</script>

<style scoped>
.sidebar-header {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 53px;
  padding: 10px 24px;
  border-bottom: 1px solid var(--detail-header-border);
  border-radius: var(--radius-lg) 0 0 0;
  background: var(--detail-header-bg);
  font-size: 1rem;
}

.sidebar-header__nav {
  display: flex;
  align-items: center;
  gap: 4px;
}

.sidebar-header__nav-btn {
  display: flex;
  align-items: center;
  padding: 2px;
  border: 0;
  border-radius: var(--radius-sm);
  background: none;
  color: var(--detail-header-title);
  cursor: pointer;
}

.sidebar-header__nav-btn:hover {
  color: var(--primary);
}

.sidebar-header__nav-btn:focus {
  outline: none;
}

.sidebar-header__titel {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.sidebar-header__zeile {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sidebar-header__link {
  display: flex;
  align-items: baseline;
  gap: 8px;
  color: var(--detail-header-title);
}

.sidebar-header__link:hover {
  color: var(--primary);
}

.sidebar-header__kuerzel {
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
}

.sidebar-header__datum {
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
}

.sidebar-header__zusatz {
  font-size: 12px;
  color: var(--text-body);
}

.sidebar-header__aktionen {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.sidebar-header__aktionen :deep(.btn.btn-icon.icon-button) {
  width: 32px;
  height: 32px;
}

.sidebar-header__close {
  display: flex;
  align-items: center;
  padding: 4px;
  margin-left: 4px;
  border: 0;
  border-radius: var(--radius-sm);
  background: none;
  color: var(--text-body);
  cursor: pointer;
}

.sidebar-header__close:focus {
  outline: none;
}
</style>
